<script>
  /**
   * @type {Boolean} - Export a variable to show or hide the release model
   */
  export let releaseModel = false

  export let isDocketLinked = false
</script>

{#if releaseModel}
  <div class="fixed inset-0 z-40 mt-0 flex flex-col items-center justify-center gap-3 overflow-hidden bg-[#000000cc] backdrop-blur-md">
    <div class="relative m-6 transform select-none rounded-md bg-white text-left transition-all dark:bg-bodyblack md:m-0 md:w-[700px]">
      <div class="flex w-full items-center justify-center rounded-md bg-white p-3 text-black dark:bg-bodyblack md:p-6">
        <h1 class="select-none text-center text-xl font-bold text-black dark:text-white lg:text-2xl xl:text-2xl">Release Document</h1>
      </div>

      <div class="break-words p-3 text-center text-gray-400 md:p-6">
        {#if isDocketLinked}
          Please confirm the release of the document, as it is linked to the docket. Once the document is released, the docket will also be released. Once released, the docket won't be viewable anymore.
        {:else}
          Do you want to&nbsp; <strong>Release</strong>
          &nbsp;this
          <strong>&nbsp;Document&nbsp;</strong>
          and want to restart the process ?
        {/if}
      </div>

      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <div class="flex flex-row items-center justify-center gap-3 rounded-md bg-white p-2 dark:bg-bodyblack sm:flex md:gap-0 md:p-4">
        <button on:click={() => (releaseModel = false)} type="button" class="flex h-9 min-h-full min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-[#f7f7f7] px-3 py-1.5 text-sm font-medium text-gray-900 hover:bg-blue-500 hover:text-white focus:outline-none disabled:cursor-not-allowed dark:bg-lightgray dark:text-white dark:hover:bg-blue-500 sm:ml-3 sm:w-auto">
          <span>
            <i class="fa-solid fa-circle-xmark" />
          </span>
          <span class="select-none">&nbsp;&nbsp;No</span>
        </button>
        <button on:click type="button" class="flex h-9 min-h-full min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-[#f7f7f7] px-3 py-1.5 text-sm font-medium text-gray-900 hover:bg-red-500 hover:text-white focus:outline-none disabled:cursor-not-allowed dark:bg-lightgray dark:text-white dark:hover:bg-red-500 sm:ml-3 sm:w-auto">
          <span>
            <i class="fa-solid fa-circle-check" />
          </span>
          <span class="select-none">&nbsp;&nbsp;Yes</span>
        </button>
      </div>
    </div>
  </div>
{/if}
